import React from "react";
import { useParams } from "react-router-dom";
import CartView from "../../carts/views/CartView";

const Cart: React.FC = () => {
    const { id } = useParams();

    return <div>
        <CartView id={Number(id)} />
    </div>;
};

export default Cart;